<template>
  <div
    class="snackbar-container"
    v-if="active"
  >
    <v-snackbar
      :color="color"
      v-model="toggle"
      :timeout="duration"
      class="snackbar"
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="$emit('close')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ['duration', 'color', 'text', 'active'],
  data() {
    return {
      toggle: false
    };
  },
  watch: {
    active(value) {
      this.toggle = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.snackbar-container {
  position: relative;
}
.snackbar {
  position: absolute;
}
</style>
